import { DefaultOptionType } from 'rc-select/es/Select';

export const availableInputTypes: Array<DefaultOptionType> = [
  { label: 'Metin', value: 'text' },
  {
    label: 'Para',
    value: 'money',
    children: [
      { label: 'TL', value: 'TRY' },
      { label: 'USD', value: 'USD' },
      { label: 'EUR', value: 'EUR' },
      { label: 'GBP', value: 'GBP' }
    ]
  },
  { label: 'Tarih', value: 'date' },
  { label: 'Sayı', value: 'numeric' }
];
